<form [formGroup]="form">
  <app-meteringpoint-form-creation-details [form]="form"></app-meteringpoint-form-creation-details>
  @if (form.get('parentMeteringPointIdentification')?.enabled) {
    <app-guide-card [fullWidth]="true" [valid]="form.get('parentMeteringPointIdentification')?.valid">
      <div title>{{ 'meteringPoint.create.child.title' | translate }}</div>
      <div description>{{ 'meteringPoint.create.child.description' | translate }}</div>
      <div>

        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meter.createform.parentid' | translate }}</label>
          <input appInput inputmode="numeric" pattern="[0-9]*"
                 formControlName="parentMeteringPointIdentification"
                 [placeholder]="'meter.createform.parentid' | translate"
                 [append]="'common.search' | translate"
                 (appendClick)="openMeteringPointModal()"
          >
        </app-input-group>
      </div>
    </app-guide-card>
  }
  <!--- Udveksling --->
  @if (form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.Exchange) {
    <app-meteringpoint-form-exchange [form]="form"></app-meteringpoint-form-exchange>
  }
  <app-meteringpoint-form-installation [form]="form"></app-meteringpoint-form-installation>
  <app-meteringpoint-form-reading-billing [form]="form"></app-meteringpoint-form-reading-billing>
  <app-meteringpoint-form-production #productionForm [form]="form" [edit]="true"></app-meteringpoint-form-production>
  <app-meteringpoint-form-address [form]="form"></app-meteringpoint-form-address>
</form>
